// extracted by mini-css-extract-plugin
export default {"wrapper":"VirtualTableOrderItem_wrapper__M0JG4","productName":"VirtualTableOrderItem_productName__tKuQb","price":"VirtualTableOrderItem_price__LtA4m"};